import React from 'react';
import { StarIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="border-y-4 border-cream-deep bg-cream px-4 py-6 sm:px-6" data-id="element-227" data-mp="3fze27tb8kvtk">
      <SectionHeading size="lg" data-id="element-228" data-mp="3fxb3mkw0pud8">
        What activity professionals are saying
      </SectionHeading>

      <div className="mx-auto mt-3.5 max-w-2xl space-y-2" data-id="element-229" data-mp="36yzfcpimj8ny">
        {testimonials.map(testimonial => <figure key={testimonial.author} className="rounded-md border border-navy/15 bg-white p-3" data-id="element-230" data-mp="31zwcnbq49ej5">
            <div className="flex gap-0.5" aria-label="Rated 5 out of 5" data-id="element-231" data-mp="2x1utyrwlrh87">
              {[0, 1, 2, 3, 4].map(index => <StarIcon key={index} className="h-3.5 w-3.5 fill-mustard text-mustard" aria-hidden="true" data-id="element-232" data-mp="2s3jhe9exasma" />)}
            </div>
            <blockquote className="mt-1.5 text-[12px] font-medium italic leading-snug text-graphite sm:text-[13px]" data-id="element-233" data-mp="q8915kwmcxgw">
              “{testimonial.text}”
            </blockquote>
            <figcaption className="mt-2 flex items-center gap-2 border-t border-cream-deep pt-2" data-id="element-234" data-mp="m6m73lf9gw7v">
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-terracotta/30 bg-terracotta/10 text-[12px] font-extrabold text-terracotta" data-id="element-235" data-mp="79bozt844s36">
                {testimonial.author.charAt(0)}
              </span>
              <span className="leading-tight" data-id="element-236" data-mp="14v9bs2tizjkx">
                <span className="block text-[12px] font-extrabold text-navy" data-id="element-237" data-mp="14uzmyik7vigt">
                  — {testimonial.author}
                </span>
                <span className="block text-[10px] font-bold uppercase tracking-wide text-graphite/70" data-id="element-238" data-mp="v5pp0m2oz5ks">
                  {testimonial.role} · {testimonial.location}
                </span>
              </span>
            </figcaption>
          </figure>)}
      </div>
    </section>;
}